import { set } from 'cerebral/operators'
export default [set('app.navigationOpen', false)]



// WEBPACK FOOTER //
// ./src/modules/user/chains/closeNavigation.js